module.exports = __webpack_public_path__ + "img/lifeflight.f0d6394.png";